import { graphql } from '@/gql';
import type { AbTestGroupCreateInput } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import util from '@/Utils/util';
import _ from 'lodash';

export const abTestGroupCreate = async (abTestGroupCreate: AbTestGroupCreateInput) => {
  const response = await mutationExecute({
    variables: { abTestGroupCreate },
    mutation: graphql(`
      mutation abTestGroupCreate($abTestGroupCreate: AbTestGroupCreateInput!) {
        abTestGroupCreate(abTestGroupCreate: $abTestGroupCreate) {
          __typename
          associatedObjectId
          associatedObjectType
          createdAt
          data
          description
          groupLabel
          groupTarget
          groupType
          id
          isActiveForAssignment
          updatedAt
          winner
        }
      }
    `),
  });

  if (response.errors?.length) {
    throw new Error(util.getGraphqlError({ graphQLErrors: response.errors }, false), { cause: response });
  }

  if (!response.data?.abTestGroupCreate) {
    throw new Error('Unexpected empty response');
  }

  return response.data.abTestGroupCreate;
};
